import { Injectable } from '@angular/core';
import { InviteEmail } from '@ktypes/models';

@Injectable({
  providedIn: 'root',
})
export class SharedConstants {
  static actionChoice = {
    clickToCreateAccount: 'click to create account',
    clickNotNow: 'click Not Now',
    clickX: 'click x',
    clickOutsideModal: 'click outside modal',
    clickBannerToCreateAccount: 'click banner to create account',
  };

  static readonly platform = 'Web';

  static readonly BATCH_THROTTLE_TIME = 350;

  static inviteEmails: InviteEmail = {
    coworker: {
      subject: 'Get started with Purposeful!',
      body: 'Through our organization, we have access to a wellbeing app called Purposeful — which helps you make progress in areas you’re trying to improve, and build positive habits. It’s free for us to use, so give it a try! Get started by following the link below.',
    },
    friend: {
      subject: 'Get the Purposeful app free with my link!',
      body: 'I’ve been using Purposeful, a wellbeing app that helps you feel better, build positive habits, and make progress on what matters to you. I thought you might like it too! This link lets you create a free account and check it out.',
    },
    spouse: {
      subject: 'Join me in Purposeful!',
      body: 'I’ve been using an app called Purposeful that helps me feel my best and be my best each day. I think you might like it! You can use this personal invite link to create a free account.',
    },
  };

  static DEFAULT_LANGUAGE = 'en';

  // NOTE: Deprecated, only a fallback, do not use as a primary source as of Jan. 30, 2025
  static supportedLanguages: { english: string; language: string; name: string }[] = [
    {
      english: 'Arabic',
      language: 'ar',
      name: 'عربي',
    },
    {
      english: 'Chinese (Simplified)',
      language: 'zh-CN',
      name: '简体中文',
    },
    {
      english: 'German',
      language: 'de',
      name: 'Deutsch',
    },
    {
      english: 'English',
      language: 'en',
      name: 'English',
    },
    {
      english: 'Spanish',
      language: 'es',
      name: 'Español',
    },
    {
      english: 'French',
      language: 'fr',
      name: 'Français',
    },
    {
      english: 'Hindi',
      language: 'hi',
      name: 'नहीं',
    },
    {
      english: 'Italian',
      language: 'it',
      name: 'Italiano',
    },
    {
      english: 'Japanese',
      language: 'ja',
      name: '日本語',
    },
    {
      english: 'Portuguese',
      language: 'pt',
      name: 'Português',
    },
  ];
}
